import { useState, useEffect } from "react";
import "./Skills.css";
import SkillItem from "./SkillItem";
// import { useAuthContext } from "../../context/AuthContext";
import { API } from "../../constant";
import { authFetch } from "../../helpers";
import Loading from "../Hooks/Loading";

const Featured = (Props) => {
    
        const [skillItems, setSkillItems] = useState([]);
        // const { user, isLoading, setUser } = useAuthContext();
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);

        useEffect(() => {
            authFetch(`${API}/skills?sort=order_id&populate=*`)
              .then((resSkill) => {
                return resSkill.json();
              })
              .then((dataSkills) => {
              
                dataSkills.data.map((item=>{
                    return item.attributes.skill_types.data
                })) 
                setSkillItems(dataSkills.data); 
                setLoading(false);
              })
              .catch((err) => {
                console.error("Error fetching skills:", err);
                setError("Unable to load skills right now. Please try again.");
                setLoading(false);
              });
          }, []);

          
    if(loading){
        return (<Loading/>)
    }
    if(error){
        return (<div className="skills"><p className="text">{error}</p></div>)
    }
    return(
        <div className="skills">
           
                <div className="skills-inner">
                    <div className="filter">
                    </div>
                        {skillItems?skillItems.map((item)=>{  
                          
                            if(item.attributes.featured_skill === true){
                                return (<SkillItem key={item.id} SklItem={item.attributes} itemId={item.id}/>)
                            }  
                        }):()=>{return "There is no item in you favorite list"}}
                </div>
            </div>
    );
}
export default Featured;